export default {
  user_id: "شناسه کاربر",
  exercise_id: "شناسه تمرین",
  question_id: "شناسه سوال",
  course_id: "شناسه دوره",
  session_id: "شناسه جلسه",
  response: "جواب",
  id: "شناسه",
  content: "محتوا",
  regarding_id: "شناسه موضوع",
  parent_id: "شناسه پدر",
  ip: "IP",
  regarding_type: "نوع موضوع",
  amount: "مقدار",
  rebate: "تخفیف",
  model_type: "مدل",
  model_id: "شناسه مدل",
  invoice_id: "شناسه فاکتور",
  gender: "جنسیت",
  first_name: "نام",
  last_name: "نام خانوادگی",
  password: "رمز عبور",
  mobile_verified_at: "تایید شماره موبایل در تاریخ",
  reference_code: "کد پیگیری",
  payed_at: "پرداخت شده در تاریخ",
  mobile: "شماره موبایل",
  email: "ایمیل",
  email_verified_at: "تایید ایمیل در تاریخ",
  authority: "شناسه تراکنش",
  uuid: "uuid",
  status: "وضعیت",
  gateway_type: "نوع درگاه پرداخت",
  answer: "جواب",
  penalty: "جریمه",
  created: "ساخته شده",
  user: "کاربر",
  updated: "بروزرسانی شده",
  transaction: "تراکنش",
  item: "آیتم",
  invoice: "فاکتور",
  comment: "نظر",
};
